"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'Academic',
    'Computer/Technology',
    'Debate/Speech',
    'Journalism/Publication',
    'Internship',
    'Research',
    'Robotics',
    'Science/Math',
    'Athletics: Club',
    'Athletics: JV/Varsity',
    'Junior R.O.T.C.',
    'Art',
    'Cultural',
    'Dance',
    'Foreign Exchange',
    'Foreign Language',
    'Music: Instrumental',
    'Music: Vocal',
    'Religious',
    'Theater/Drama',
    'Career Oriented',
    'Family Responsibilities',
    'Other Club/Activity',
    'Work (paid)',
    'Community Service (volunteer)',
    'Environmental',
    'LGBT',
    'School Spirit',
    'Social Justice',
    'Student Govt/Politics',
];
//# sourceMappingURL=ecActivities.js.map